import React, { HTMLAttributes } from "react";
import PropTypes from "prop-types";
import _ from "lodash";

import Viewport from "component/molecules/viewport";

import Synchronizer from "component/molecules/viewport/tools/sync/Synchronizer";

import { clearElementState } from "component/toolManager/toolState.js";

import pubsub from "core/global/global";

import Cache from "core/cache";
import CustomEvent from "core/customEvent";
import store from "core/store/";
import "./GridViewportSection.styl";
import { clearAll } from "../../toolManager/toolState";
import stackImagePositionSynchronizer from "component/molecules/viewport/tools/sync/stackImagePositionSynchronizer";
import panZoomSynchronizer from "component/molecules/viewport/tools/sync/panZoomSynchronizer";
import wwwcSynchronizer from "component/molecules/viewport/tools/sync/wwwcSynchronizer";
import updateImageSynchronizer from "component/molecules/viewport/tools/sync/updateImageSynchronizer";

import { inject } from "mobx-react";
import { getEnabledElements } from "component/toolManager/enabledElements.js";
import BaseBrushTool from "component/molecules/viewport/tools/annotation/base/BaseBrushTool";
import { getToolState } from "component/toolManager/toolState.js";
//declare var pubsub: any;

const TOP_CLASS = "top";
const BOTTOM_CLASS = "bottom";
const MIDDLE_CLASS = "middle";

export let gridLayoutInstance: any = null;

interface layoutRowsCols {
  rows: number;
  cols: number;
}

/**
 * @description GridLayout UI Component Properties
 *
 * @interface IGridLayoutProps
 * @extends {HTMLAttributes<HTMLDivElement>}
 */
interface IGridLayoutProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * @description 기본 그리드 레이아웃 행 값
   */
  rows: number;
  /**
   * @description 기본 그리드 레이아웃 열 값
   */
  cols: number;
  /**
   * @description 그리드 레이아웃 최대 행 값
   */
  maxRows: number;
  /**
   * @description 그리드 레이아웃 최대 열 값
   */
  maxCols: number;
  /**
   * @description 그리드 레이아웃 최대 열 값
   */
  viewport: any;

}

/**
 * @description GridLayout UI Component Properties
 *
 * @interface IGridLayoutStates
 * @extends {HTMLAttributes<HTMLDivElement>}
 */
interface IGridLayoutStates extends HTMLAttributes<HTMLDivElement> {
  /**
   * @description 현재 확장 UI 열림/닫힘 상태
   */
  data: any;
  renderDataMap: any; // key-based index in order array
  rows: number;
  cols: number;
  renderViewOrder: any;
  renderViewScrollIndex: any; // key-based index in order array
  renderViewViewportConfig: any; // key-based index in order array
  renderViewContrastOption: any; // key-based index in order array
  renderViewEnabledElements: any;
  activeViewportIdx: number;

  activeToolName: any;
  activeToolColor: any;

  prevRows: number;
  prevCols: number;
  prevViewportIdx: number;
}

@inject("sarcopeniaMeasureStore")
class GridLayout extends React.Component<IGridLayoutProps, IGridLayoutStates> {
  private isBlockUpdate = false;

  public slicePositionSync: any;
  public panZoomSync: any;
  public wwwcSync: any;
  public updateImageSync: any;

  static propTypes: PropTypes.InferProps<IGridLayoutProps>;

  static defaultProps = {
    rows: 1,
    cols: 1,
    maxRows: 4,
    maxCols: 4,
    viewport: ""
  };

  constructor(props: any) {
    super(props);

    this.state = {
      data: undefined,
      renderDataMap: new Map(), // key-based index in order array
      rows: props.rows,
      cols: props.cols,
      renderViewOrder: [],
      renderViewScrollIndex: [], // key-based index in order array
      renderViewViewportConfig: [], // key-based index in order array
      renderViewContrastOption: [],
      renderViewEnabledElements: [],
      activeViewportIdx: -1,

      activeToolName: "none",
      activeToolColor: "none",

      prevRows: -1,
      prevCols: -1,
      prevViewportIdx: 0
    };
    // for temp
    gridLayoutInstance = this;
    ///
    /// viewport 렌더링 순서 초기화
    /// (추후 별도 모델을 만들어서 초기화)
    ///
    for (let i = 0; i < props.maxRows * props.maxCols; i++) {
      this.state.renderViewOrder.push(i);
    }

    ///
    /// 각 viewport 스크롤 저장 배열 초기화
    /// (추후 별도 모델을 만들어서 초기화)
    ///
    for (let i = 0; i < props.maxRows * props.maxCols; i++) {
      this.state.renderViewScrollIndex.push(0);
    }

    ///
    /// 각 viewport 설정 값 저장 배열 초기화
    /// (추후 별도 모델을 만들어서 초기화)
    ///
    for (let i = 0; i < props.maxRows * props.maxCols; i++) {
      this.state.renderViewViewportConfig.push(null);
    }

    ///
    /// 각 viewport Contrast 설정 값 저장 배열 초기화
    /// (추후 별도 모델을 만들어서 초기화)
    ///
    for (let i = 0; i < props.maxRows * props.maxCols; i++) {
      this.state.renderViewContrastOption.push("");
    }

    for (let i = 0; i < props.maxRows * props.maxCols; i++) {
      this.state.renderViewEnabledElements.push(null);
    }

    this.updateImageSync = new Synchronizer(
      CustomEvent.EVENTS.NEW_IMAGE,
      updateImageSynchronizer
    );
  }

  componentDidMount = () => {
    ///
    /// subscriber 등록
    ///
    /// 요청시 viewport로 데이터 전달
    (pubsub as any).subscribe(
      CustomEvent.Messages.DELIVER_DATA_TO_VIEWPORT,
      this.handleSendDataToViewport
    );

    /// 해당 viewport 데이터 초기화
    (pubsub as any).subscribe(
      CustomEvent.Messages.REQUEST_SEND_TO_VIEWPORT,
      this.handleRequestInit
    );
    /// 레이아웃 변경
    (pubsub as any).subscribe(
      CustomEvent.Messages.CHANGE_VIEWPORT_ARRAY,
      this.handleChangeViewportArray
    );
    /// 데이터 삭제
    (pubsub as any).subscribe(
      CustomEvent.Messages.REMOVE_METADATA,
      this.handleRemoveOneViewport
    );
    /// 모든 데이터 삭제
    (pubsub as any).subscribe(
      CustomEvent.Messages.CLEAR_ALL_METADATA,
      this.handleClearAllViewport.bind(this)
    );
    /// 활성화 viewport 변경
    (pubsub as any).subscribe(
      CustomEvent.Messages.CHANGE_ACTIVE_VIEWPORT,
      this.handleActiveViewport
    );
    /// 현재 viewport 닫기
    (pubsub as any).subscribe(
      CustomEvent.Messages.REMOVE_VIEWPORT,
      this.handleRemoveViewport
    );
    (pubsub as any).subscribe(
      CustomEvent.Messages.CLEAR_VIEWPORT,
      this.handleClearAllViewport
    );
    /// 1x1 layout 전환
    (pubsub as any).subscribe(
      CustomEvent.Messages.VIEW_ONE_VIEWPORT,
      this.handleOnebyOneLayout
    );
    (pubsub as any).subscribe(
      CustomEvent.Messages.SET_CONTRAST_MODE_ON_ACTIVE,
      this.handleSetContrastModeOnActive
    );
    (pubsub as any).subscribe(
      CustomEvent.Messages.SET_ACTIVE_TOOL,
      this.handleSetActiveTool
    );
    (pubsub as any).subscribe(
      CustomEvent.Messages.SET_ANNOTATION_ACTIVE_TOOL,
      this.handleSetAnnotationActiveTool
    );

    store.SelectedMeasure.setSelectedMeasure("");
    (pubsub as any).publish(
      CustomEvent.Messages.SET_ACTIVE_TOOL,
      "BrowseSeries"
    );

    this.slicePositionSync = new Synchronizer(
      "scroll-index-changed",
      stackImagePositionSynchronizer
    );
    this.panZoomSync = new Synchronizer(
      CustomEvent.EVENTS.PAN_ZOOM_CHANGED,
      panZoomSynchronizer
    );
    this.wwwcSync = new Synchronizer(
      CustomEvent.EVENTS.WWWC_CHANGED,
      wwwcSynchronizer
    );
  };
  componentDidUpdate = () => {
    if (this.isBlockUpdate) {
      this.isBlockUpdate = false;
    }
  };
  componentWillUnmount = () => {
    ///
    /// subscriber 해제
    ///
    /// 요청시 viewport로 데이터 전달
    (pubsub as any).unsubscribe(
      CustomEvent.Messages.DELIVER_DATA_TO_VIEWPORT,
      this.handleSendDataToViewport
    );

    /// 해당 viewport 데이터 초기화
    (pubsub as any).unsubscribe(
      CustomEvent.Messages.REQUEST_SEND_TO_VIEWPORT,
      this.handleRequestInit
    );
    /// 레이아웃 변경
    (pubsub as any).unsubscribe(
      CustomEvent.Messages.CHANGE_VIEWPORT_ARRAY,
      this.handleChangeViewportArray
    );
    /// 데이터 삭제
    (pubsub as any).unsubscribe(
      CustomEvent.Messages.REMOVE_METADATA,
      this.handleRemoveOneViewport
    );
    /// 모든 데이터 삭제
    (pubsub as any).unsubscribe(
      CustomEvent.Messages.CLEAR_ALL_METADATA,
      this.handleClearAllViewport
    );
    /// 활성화 viewport 변경
    (pubsub as any).unsubscribe(
      CustomEvent.Messages.CHANGE_ACTIVE_VIEWPORT,
      this.handleActiveViewport
    );
    /// 현재 viewport 닫기
    (pubsub as any).unsubscribe(
      CustomEvent.Messages.REMOVE_VIEWPORT,
      this.handleRemoveViewport
    );
    (pubsub as any).unsubscribe(
      CustomEvent.Messages.CLEAR_VIEWPORT,
      this.handleClearAllViewport
    );
    /// 1x1 layout 전환
    (pubsub as any).unsubscribe(
      CustomEvent.Messages.VIEW_ONE_VIEWPORT,
      this.handleOnebyOneLayout
    );

    (pubsub as any).unsubscribe(
      CustomEvent.Messages.SET_CONTRAST_MODE_ON_ACTIVE,
      this.handleSetContrastModeOnActive
    );

    (pubsub as any).unsubscribe(
      CustomEvent.Messages.SET_ACTIVE_TOOL,
      this.handleSetActiveTool
    );
    (pubsub as any).unsubscribe(
      CustomEvent.Messages.SET_ANNOTATION_ACTIVE_TOOL,
      this.handleSetAnnotationActiveTool
    );
  };

  getLayoutRowsCols(): layoutRowsCols {
    const { rows, cols } = this.state;
    const layout: layoutRowsCols = {
      rows: rows,
      cols: cols
    };

    return layout;
  }

  getActiveViewportDump(): any {
    const {
      activeViewportIdx,
      renderDataMap,
      renderViewScrollIndex
    } = this.state;
    if (!renderDataMap.has(activeViewportIdx)) {
      return [];
    }
    const scrollIdx = renderViewScrollIndex[activeViewportIdx];
    let metadataCache = new Cache.Metadata();
    const dataKey = renderDataMap.get(activeViewportIdx);
    const image = metadataCache.getFrame(dataKey, scrollIdx);

    return image.dump;
  }

  getActiveViewportPatientInfo(): any {
    const {
      activeViewportIdx,
      renderDataMap,
      renderViewScrollIndex
    } = this.state;
    if (!renderDataMap.has(activeViewportIdx)) {
      return [];
    }
    const scrollIdx = renderViewScrollIndex[activeViewportIdx];
    let metadataCache = new Cache.Metadata();
    const dataKey = renderDataMap.get(activeViewportIdx);
    const frame = metadataCache.getFrame(dataKey, scrollIdx);

    const patientInfo = {
      modality: frame.modality,
      patientName: frame.patientName,
      studyDescription: frame.studyDescription
    };

    return patientInfo;
  }

  getActiveViewportIndex(): number {
    const { activeViewportIdx } = this.state;

    return activeViewportIdx;
  }

  getEmptyViewportIndex(): number {
    //const { maxRows, maxCols } = this.props;
    let { renderDataMap, rows, cols } = this.state;

    ///
    /// 1. 빈 DCMView를 찾는다.
    ///
    let isUsingView = [];
    for (let i = 0; i < rows * cols; i++) {
      isUsingView.push(false);
    }

    renderDataMap.forEach((value: any, key: any) => {
      if (key < isUsingView.length) isUsingView[key] = true;
    });

    let foundEmptyViewIndex = -1;

    for (let i = 0; i < rows * cols; i++) {
      if (isUsingView[i] === true) {
        continue;
      }
      foundEmptyViewIndex = i;
      break;
    }

    return foundEmptyViewIndex;
  }

  getViewportElementByIndex(index: number): any {
    const { renderViewEnabledElements } = this.state;
    if (index > renderViewEnabledElements.length - 1) {
      return null;
    }

    return renderViewEnabledElements[index];
  }

  handleSetContrastModeOnActive = (mode: any, msg: any) => {
    const { activeViewportIdx } = this.state;

    if (activeViewportIdx === -1) {
      return;
    }

    this.state.renderViewContrastOption[activeViewportIdx] = mode;
  };

  handleSetActiveTool = (toolData: any, msg: any) => {
    if (toolData && typeof toolData === "object" && !Array.isArray(toolData)) {
      const { toolName, color } = toolData;

      this.setState({ activeToolName: toolName, activeToolColor: color });
      // 여기서 toolName과 color 사용
    } else {
      // const tmp_toolName = toolData;
      const toolName = toolData;
      this.setState({ activeToolName: toolName });
      // 여기서 toolName만 사용
    }
    
    // if (typeof toolName !== "string") {
    //   return;
    // }

    
  };

  handleSetAnnotationActiveTool = (toolName: any, msg: any) => {
    if (typeof toolName !== "string") {
      return;
    }

    this.setState({ activeToolName: toolName });
  };

  sendToViewport = (foundDCMViewIdx: any, payload: any) => {
    let { rows, cols } = this.state;
    /// 빈 DCMView가 없는경우, 종료
    if (foundDCMViewIdx === -1 || foundDCMViewIdx >= rows * cols) {
      return;
    }

    /// DCMView 데이터 전달 요청
    const requestData = {
      viewportIndex: foundDCMViewIdx,
      seriesInstanceUID: payload.seriesInstanceUID || "None-Series",
      modality: payload.modality || "None-Modality"
    };
    (pubsub as any).publish(
      CustomEvent.Messages.REQUEST_SEND_TO_VIEWPORT,
      requestData
    );

    /// 특정 viewport 를 활성화 상태로 변경한다.
    //PubSub.publish(CustomEvent.Messages.CHANGE_ACTIVE_VIEWPORT, requestData);
    (pubsub as any).publish(
      CustomEvent.Messages.CHANGE_ACTIVE_VIEWPORT,
      foundDCMViewIdx
    );

    const sendPayload = {
      seriesInstanceUID: payload.seriesInstanceUID,
      modality: payload.modality
    };

    (pubsub as any).publish(
      CustomEvent.Messages.SET_ACTIVE_SPECIFIC_SERIES,
      sendPayload
    );
  };

  /**
   * @method handleSendDataToViewport
   * @param msg 메세지 구분 이름
   * @param data 전달 데이터
   * @description 데이터를 요청받은 i번쨰 viewport로 전달
   * @memberof GridLayout
   */
  handleSendDataToViewport = (payload: any, msg: any) => {
    const { renderViewOrder, renderDataMap } = this.state;

    let foundIdx = -1;
    renderViewOrder.forEach(function(item: any, index: any) {
      if (payload.viewportIndex === item) {
        foundIdx = index;
      }
    });

    if (foundIdx === -1) {
      return;
    }

    renderDataMap.set(foundIdx, payload.data); // = data.data;

    this.initializeSynchronization();
    this.setState({ data: payload.data, renderDataMap: renderDataMap });
    (pubsub as any).publish(CustomEvent.Messages.VIEWPORT_RENDER, foundIdx);
  };

  initializeSynchronization = () => {
    const { renderViewEnabledElements, renderDataMap } = this.state;
    (this.slicePositionSync as any).destroy();
    (this.panZoomSync as any).destroy();
    (this.wwwcSync as any).destroy();
    (this.updateImageSync as any).destroy();

    ///
    /// Source DCMView 찾기
    ///
    let sourceElements: any = [];
    //let sourceUIDs = [];
    let sourceMapIdxs: any = [];
    renderDataMap.forEach((value: any, dataMapIdx: any) => {
      const elementStub = renderViewEnabledElements[dataMapIdx];
      sourceElements.push(elementStub.element);
      //sourceUIDs.push(value);
      sourceMapIdxs.push(dataMapIdx);
    });

    sourceElements.forEach((sourceElement: any, sourceIdx: any) => {
      let targetElements: any[] = [];
      renderDataMap.forEach((value: any, dataMapIdx: any) => {
        let metadataCache = new Cache.Metadata();
        const targetStudyUID = metadataCache.getStudyInstanceUID(value);
        const sourceKey = renderDataMap.get(sourceMapIdxs[sourceIdx]);
        const sourceStudyUID = metadataCache.getStudyInstanceUID(sourceKey);
        const elementStub = renderViewEnabledElements[dataMapIdx];

        if (
          sourceStudyUID === targetStudyUID &&
          sourceElement !== elementStub.element
        ) {
          targetElements.push(elementStub.element);
        }
      });

      /// slice position sync
      (this.slicePositionSync as any).add(sourceElement, targetElements);
      /// pan/zoom sync
      (this.panZoomSync as any).add(sourceElement, targetElements);
      /// wwwc sync
      (this.wwwcSync as any).add(sourceElement, targetElements);
      /// update image sync
      (this.updateImageSync as any).add(sourceElement, targetElements);
    });
    ///
    /// Target DCMView 찾기
    ///

    //------------------------------------------------------------------
  };

  handleRegisteredElement = (key: any, enabledElement: any) => {
    if (this.isBlockUpdate) return;
    let { renderViewEnabledElements } = this.state;

    renderViewEnabledElements[key] = enabledElement;
  };

  /**
   * @method handleRequestInit
   * @param msg 메세지 구분 이름
   * @param data 전달 데이터
   * @description 전달받은 i 번째 viewport 초기화
   * @memberof GridLayout
   */

  handleRequestInit = (dataset: any, msg: any) => {
    let {
      renderViewOrder,
      renderViewScrollIndex,
      renderDataMap,
      renderViewViewportConfig,
      renderViewContrastOption,
      renderViewEnabledElements
    } = this.state;

    let orderIdx = dataset.viewportIndex; //order
    let foundIdx = -1;

    renderViewOrder.forEach(function(item: any, index: any) {
      if (orderIdx === item) {
        foundIdx = index;
      }
    });

    if (foundIdx !== -1) {
      renderViewScrollIndex[foundIdx] = 0;
      renderDataMap.delete(foundIdx);
      renderViewViewportConfig[foundIdx] = null;
      renderViewContrastOption[foundIdx] = "";

      ///--------------
      const targetElement = renderViewEnabledElements[foundIdx].element;
      this.slicePositionSync.removeTarget(targetElement);
      this.slicePositionSync.removeSource(targetElement);
      this.panZoomSync.removeTarget(targetElement);
      this.panZoomSync.removeSource(targetElement);
      this.wwwcSync.removeTarget(targetElement);
      this.wwwcSync.removeSource(targetElement);
      this.updateImageSync.removeTarget(targetElement);
      this.updateImageSync.removeSource(targetElement);
    }

    this.setState({
      renderViewScrollIndex: renderViewScrollIndex,
      renderDataMap: renderDataMap,
      renderViewViewportConfig: renderViewViewportConfig,
      renderViewContrastOption: renderViewContrastOption
    });
  };
  /**
   * @description
   * @method handleCHangeViewportArray
   * @memberof GridLayout
   */
  handleChangeViewportArray = (data: any, msg: any) => {
    let {
      prevRows,
      prevCols,
      prevViewportIdx,
      renderViewOrder,
      rows,
      cols
    } = this.state;

    if (prevRows !== -1 && cols !== -1) {
      const viewportIndex = prevViewportIdx;

      // change renderMap
      renderViewOrder[0] = 0;
      renderViewOrder[viewportIndex] = viewportIndex;
      /// init relative state
      prevRows = -1;
      prevCols = -1;
    }
    rows = data.rows;
    cols = data.cols;

    this.setState({
      renderViewOrder: renderViewOrder,
      prevRows: prevRows,
      prevCols: prevCols,
      rows: rows,
      cols: cols
    });
  };

  /**
   * @description 전달받은 Series Instance UID와 동일한 값을 가진
   * 데이터를 가진 한개 viewport 데이터 삭제  시리즈 뷰에서 삭제
   * @method handleRemoveOneViewport
   * @param msg 메세지 이름 문자열
   * @param seriesInstanceUID series instance uid
   * @memberof GridLayout
   */
  //handleRemoveOneViewport = (msg, seriesInstanceUID) => {
  handleRemoveOneViewport = (responseData: any, msg: any) => {
    this.isBlockUpdate = true;
    let {
      renderDataMap,
      renderViewViewportConfig,
      renderViewContrastOption,
      renderViewEnabledElements
    } = this.state;
    const { seriesInstanceUID, modality } = responseData;

    const targetSeriesInstanceKey = Cache.KeyGen.makeKey(
      seriesInstanceUID,
      modality
    );

    let foundKey = -1;
    renderDataMap.forEach((value: any, key: any) => {
      const data = renderDataMap.get(key);
      if (data === targetSeriesInstanceKey) {
        renderDataMap.delete(key);
        foundKey = key;
      }
    });

    if (foundKey === -1) {
      return;
    }

    if (foundKey !== -1) {
      clearElementState(renderViewEnabledElements[foundKey].element);
      renderViewViewportConfig[foundKey] = null;
      renderViewContrastOption[foundKey] = "";
      renderViewEnabledElements[foundKey].image = undefined;
      renderViewEnabledElements[foundKey].data = {};
      renderViewEnabledElements[foundKey].renderingTools = {};

      ///--------------
      const targetElement = renderViewEnabledElements[foundKey].element;
      this.slicePositionSync.removeTarget(targetElement);
      this.slicePositionSync.removeSource(targetElement);
      this.panZoomSync.removeTarget(targetElement);
      this.panZoomSync.removeSource(targetElement);
      this.wwwcSync.removeTarget(targetElement);
      this.wwwcSync.removeSource(targetElement);
      this.updateImageSync.removeTarget(targetElement);
      this.updateImageSync.removeSource(targetElement);
    }

    // find index in map by value
    this.setState({
      renderDataMap: renderDataMap,
      renderViewViewportConfig: renderViewViewportConfig,
      renderViewContrastOption: renderViewContrastOption
    });
  };

  /**
   * @description 전체 viewport 데이터 삭제
   * @method handleClearAllViewport
   * @param msg 메시지 이름 문자열
   * @memberof GridLayout
   */
  handleClearAllViewport = () => {
    this.isBlockUpdate = true;
    let {
      data,
      renderDataMap,
      renderViewOrder,
      renderViewScrollIndex,
      renderViewViewportConfig,
      renderViewContrastOption,
      renderViewEnabledElements
    } = this.state;

    const { maxRows, maxCols } = this.props;

    data = undefined;
    renderDataMap.clear();
    renderViewOrder = [];
    renderViewScrollIndex = [];
    renderViewViewportConfig = [];

    for (let i = 0; i < maxRows * maxCols; i++) {
      renderViewOrder.push(i);
    }
    for (let i = 0; i < maxRows * maxCols; i++) {
      renderViewScrollIndex.push(0);
    }
    for (let i = 0; i < maxRows * maxCols; i++) {
      renderViewViewportConfig.push(null);
    }
    for (let i = 0; i < maxRows * maxCols; i++) {
      renderViewContrastOption.push("");
    }

    for (let i = 0; i < maxRows * maxCols; i++) {
      renderViewContrastOption.push("");
    }
    for (let i = 0; i < maxRows * maxCols; i++) {
      renderViewEnabledElements.push(null);
    }
    clearAll();

    this.slicePositionSync.destroy();
    this.panZoomSync.destroy();
    this.wwwcSync.destroy();
    this.updateImageSync.destroy();

    // find index in map by value
    this.setState({
      data: data,
      renderDataMap: renderDataMap,
      renderViewOrder: renderViewOrder,
      renderViewScrollIndex: renderViewScrollIndex,
      renderViewViewportConfig: renderViewViewportConfig,
      renderViewContrastOption: renderViewContrastOption
    });
  };

  /**
   * @description i 번째 viewport 활성화
   * @method handleActiveViewport
   * @param msg 메세지 이름 문자열
   * @param activeViewportIdx 활성화 되는 viewport Index
   * @memberof GridLayout
   */
  handleActiveViewport = (activeViewportIdx: any, msg: any) => {
    ///
    /// 활성화된 Viewport에 대한 Synchronize 대상 DCMView 수집
    /// 수집 대상 Viewport는 Study Instance UID 가 동일한 데이터를 출력하는 DCMView
    ///

    const { renderDataMap, renderViewEnabledElements } = this.state;
    if (!renderDataMap.has(activeViewportIdx)) {
      this.setState({ activeViewportIdx: activeViewportIdx });
      return;
    }

    ///
    /// UI 리-렌더링(re-rendering)
    ///
    this.setState({ activeViewportIdx: activeViewportIdx });
  };

  /**
   * @description i번째 viewport 데이터 삭제
   * @method handleRemoveViewport
   * @param msg 메세지 문자열
   * @param viewportIdx 삭제 대상 viewport 인덱스
   * @memberof GridLayout
   */
  handleRemoveViewport = (viewportIdx: any, msg: any) => {
    this.isBlockUpdate = true;
    let {
      renderDataMap,
      renderViewScrollIndex,
      renderViewViewportConfig,
      renderViewContrastOption,
      renderViewEnabledElements
    } = this.state;

    renderDataMap.delete(viewportIdx); // = data.data;

    if (viewportIdx !== -1) {
      renderViewScrollIndex[viewportIdx] = 0;
      renderViewViewportConfig[viewportIdx] = null;
      renderViewContrastOption[viewportIdx] = "";

      const targetElement = renderViewEnabledElements[viewportIdx].element;

      this.slicePositionSync.removeTarget(targetElement);
      this.slicePositionSync.removeSource(targetElement);
      this.panZoomSync.removeTarget(targetElement);
      this.panZoomSync.removeSource(targetElement);
      this.wwwcSync.removeTarget(targetElement);
      this.wwwcSync.removeSource(targetElement);
      this.updateImageSync.removeTarget(targetElement);
      this.updateImageSync.removeSource(targetElement);
    }

    (pubsub as any).publish(CustomEvent.Messages.VIEWPORT_RENDER, viewportIdx);

    // find index in map by value
    this.setState({
      renderDataMap: renderDataMap,
      renderViewScrollIndex: renderViewScrollIndex,
      renderViewViewportConfig: renderViewViewportConfig,
      renderViewContrastOption: renderViewContrastOption
    });
  };

  /**
   * @method handleOnebyOneLayout
   * @param msg 메세지 이름 문자열
   * @param viewportIndex 1x1 되는 viewport의 인덱스
   * @description
   * @memberof GridLayout
   */
  handleOnebyOneLayout = (viewportIndex: any, msg: any) => {
    let {
      rows,
      cols,
      prevRows,
      prevCols,
      prevViewportIdx,
      renderViewOrder
    } = this.state;

    if (rows === 1 && cols === 1) {
      if (prevRows === -1 && prevCols === -1) {
        return;
      }

      /// rollback layout
      rows = prevRows;
      cols = prevCols;

      /// rollback rendermap
      // change renderMap
      renderViewOrder[0] = 0;
      renderViewOrder[prevViewportIdx] = prevViewportIdx;

      /// reset related state
      prevCols = -1;
      prevRows = -1;
    } else {
      /// Enter 1x1 viewport layout
      // backup current layout
      prevRows = rows;
      prevCols = cols;
      prevViewportIdx = viewportIndex;

      // set 1x1 layout
      rows = 1;
      cols = 1;

      // change renderMap
      renderViewOrder[0] = viewportIndex;
      renderViewOrder[viewportIndex] = 0;
    }

    this.setState({
      rows: rows,
      cols: cols,
      prevRows: prevRows,
      prevCols: prevCols,
      prevViewportIdx: prevViewportIdx,
      renderViewOrder: renderViewOrder
    });
    this.initializeSynchronization();
  };

  /**
   * @method handleChangeViewport
   * @description viewport 설정값 변경시, 변경된 설정값 저장 핸들러
   * @memberof GridLayout
   */

  handleChangeViewport = (
    viewportKeyIdx: any,
    viewportConfig: any,
    activeTool: any
  ) => {
    if (this.isBlockUpdate) {
      return;
    }
    if (!viewportConfig) {
      return;
    }
    this.state.renderViewViewportConfig[viewportKeyIdx] = _.cloneDeep(
      viewportConfig
    );

    if (activeTool === "WwwcTool") {
      this.state.renderViewContrastOption[viewportKeyIdx] = "";
    }

    //this.setState({ renderViewViewportConfig: renderViewViewportConfig });
  };

  /**
   * @method handleScroll
   * @description viewport의 스크롤 변경시, 변경된 스크롤 값 저장 핸들러
   * @memberof GridLayout
   */
  handleScroll = (viewportIdx: any, imageViewIdx: any) => {
    let { renderViewScrollIndex } = this.state;

    renderViewScrollIndex[viewportIdx] = imageViewIdx;
    //this.setState({ renderViewScrollIndex: renderViewScrollIndex });
  };
  setContrastOptionOfActiveViewport(option: any) {
    const { renderViewContrastOption, activeViewportIdx } = this.state;
    if (activeViewportIdx === -1) {
      return "";
    }
    renderViewContrastOption[activeViewportIdx] = option;
  }
  getContrastOptionOfActiveViewport() {
    const { renderViewContrastOption, activeViewportIdx } = this.state;
    if (activeViewportIdx === -1) {
      return "";
    }
    let contrastOption = renderViewContrastOption[activeViewportIdx];

    return contrastOption;
  }
  getContrastOptionById(id: any) {
    const { renderViewContrastOption } = this.state;
    if (typeof id !== "number") {
      return "";
    }

    if (id < 0 || id >= renderViewContrastOption.length) {
      return "";
    }

    let contrastOption = renderViewContrastOption[id];

    return contrastOption;
  }
  toggleIsNagativeOfActiveViewport() {
    const { renderViewViewportConfig, activeViewportIdx } = this.state;
    if (activeViewportIdx === -1) {
      return;
    }
    const viewport = renderViewViewportConfig[activeViewportIdx];
    if (_.get(viewport, "invert")) {
      viewport.invert = !viewport.invert;
    }
  }
  getIsNagativeOfActiveViewport() {
    const { renderViewViewportConfig, activeViewportIdx } = this.state;
    if (activeViewportIdx === -1) {
      return false;
    }
    const viewport = renderViewViewportConfig[activeViewportIdx];
    if (_.get(viewport, "invert")) {
      return viewport.invert;
    } else {
      return false;
    }
  }
  /**
   * @method setActiveViewport
   * @description 활성화 viewport 변경
   * @param {*} viewportIdx
   * @memberof GridLayout
   */
  setActiveViewport(viewportIdx: any) {
    this.setState({ activeViewportIdx: viewportIdx });
  }

  /**
   * @method getViewports
   * @description 모든 viewport 설정 반환
   * @return 모든 viewport 설정
   * @memberof GridLayout
   */

  getViewports() {
    const numViewport = this.state.rows * this.state.cols;
    const rows = this.state.rows;
    const cols = this.state.cols;

    var viewports = [];
    for (let i = 0; i < numViewport; i++) {
      const viewportIndex = this.state.renderViewOrder[i];
      viewports.push({
        viewportIndex: viewportIndex,
        rows,
        cols
      });
    }

    return viewports;
  }

  /**
   * @method getViewportHeight
   * @description 현재 레이아웃 설정에서 viewport 높이 계산해서 반환
   * @returns 현재 레이아웃 설정에서 viewport 높이 계산
   * @memberof GridLayout
   */
  getViewportHeight() {
    const rows = this.state.rows || 1;
    return 100 / rows;
  }

  /**
   * @method getViewportWidth
   * @description 현재 레이아웃 설정에서 viewport 너비 계산해서 반환
   * @returns 현재 레이아웃 설정에서 viewport 너비 계산
   * @memberof GridLayout
   */

  getViewportWidth() {
    const cols = this.state.cols || 1;
    return 100 / cols;
  }

  /**
   * @method getViewportPositionClass
   * @description i번째 viewport의 위치 정보를 표시하는 클래스 리턴
   * @returns i번째 viewport의 위치 정보를 표시하는 클래스 리턴
   * @todo (추후 CSS에 활용..?)
   * @memberof GridLayout
   */

  getViewportPositionClass(index: any) {
    const { rows, cols } = this.state;

    if (rows === 1) {
      return `${TOP_CLASS} ${BOTTOM_CLASS}`;
    }

    const actualRow = Math.floor(index / cols);

    if (actualRow === 0) {
      return TOP_CLASS;
    }
    if (actualRow + 1 === rows) {
      return BOTTOM_CLASS;
    }

    return MIDDLE_CLASS;
  }

  /**
   * @method getLayoutClass
   * @description 현재 레이아웃 설정 클래스를 리턴
   * @returns 현재 레이아웃 설정 클래스를 리턴
   * @memberof GridLayout
   */
  getLayoutClass() {
    const rows = this.state.rows;
    const cols = this.state.cols;
    const layoutClass = `layout-${rows}-${cols}`;

    return layoutClass;
  }

  /**
   * @method renderViewport
   * @description i 번 Viewport를 렌더링
   * @param {*} i
   * @returns 렌더링된 viewport의 react element
   * @memberof GridLayout
   */
  renderViewport(i: any) {
    var data = undefined;
    if (this.state.renderDataMap.has(i)) {
      data = this.state.renderDataMap.get(i);
    }
    const layoutString = this.state.rows + "x" + this.state.cols;

    let isActive = false;

    if (this.state.activeViewportIdx === i) {
      isActive = true;
    }
    const viewport = this.state.renderViewViewportConfig[i];

    return (
      <Viewport
        //index={i}
        id={"viewport-" + i}
        identifier={i}
        isActive={isActive}
        data={data}
        layoutString={layoutString}
        viewport={viewport}
        scrollIdx={this.state.renderViewScrollIndex[i]}
        width={this.getViewportWidth()}
        height={this.getViewportHeight()}
        activeTool={this.state.activeToolName}
        activeColor={this.state.activeToolColor}
        onScroll={this.handleScroll}
        onChangeViewport={this.handleChangeViewport}
        onRegisteredElement={this.handleRegisteredElement}
      />
    );
  }

  /**
   * @method render
   * @description GridViewportSection UI 컴포넌트 렌더링
   * @returns
   * @memberof GridLayout
   */
  render() {
    return (
      <div id="layoutManagerTarget" className={this.getLayoutClass()}>
        <div id="imageViewerViewports">
          {this.getViewports().map(viewport => {
            // forEach doesn't work
            return (
              <div
                key={viewport.viewportIndex}
                className={
                  "viewportContainer " +
                  this.getViewportPositionClass(viewport.viewportIndex)
                }
                id="viewportContainer"
                style={{
                  height: this.getViewportHeight() + "%",
                  width: this.getViewportWidth() + "%"
                }}
              >
                {this.renderViewport(viewport.viewportIndex)}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default GridLayout;
